module.exports = __webpack_public_path__ + "img/terroir-tinted-4.d2f238be.jpg";